import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AdContainer } from './subNavStyles';
import SubNavAd from './SubNavAd';

class SubNavAdSpace extends PureComponent {
	render() {
		const ads = this.props.ads;
		if (ads.length === 0) return null;

		return (
			<AdContainer>
				{ads.map((ad, n) => <SubNavAd key={n} {...ad} />)}
			</AdContainer>
		);
	}

	static propTypes = {
		slug: PropTypes.string.isRequired,
		ads: PropTypes.array,
	}
}

export default SubNavAdSpace;
